import {
	createInitialJsonSchemaObject,
	type JsonObject,
	toJsonObject,
	toRjsfSchema,
} from "src/components/common/forms/jsonSchema/jsonSchemaObjectInputUtils.ts";

export function createInitialCustomFunctionUiActionUserInput(schema: unknown, formData: unknown): JsonObject {
	return createInitialJsonSchemaObject(schema, formData);
}

export function prepareCustomFunctionUiActionUserInput(schemaValue: unknown, formData: unknown): JsonObject {
	const schema = toRjsfSchema(schemaValue);
	const userInput = { ...toJsonObject(formData) };
	const requiredFields = Array.isArray(schema.required) ? schema.required : [];

	for (const fieldName of requiredFields) {
		const fieldSchema = schema.properties?.[fieldName];
		if (!isSchemaObject(fieldSchema) || fieldSchema.type !== "boolean") continue;
		if (typeof userInput[fieldName] === "boolean") continue;
		userInput[fieldName] = typeof fieldSchema.default === "boolean" ? fieldSchema.default : false;
	}

	return userInput;
}

function isSchemaObject(value: unknown): value is Record<string, unknown> {
	return value != null && typeof value === "object" && !Array.isArray(value);
}
